import { PolicyLayout, useSettings, ConfigField } from "@/components/PolicyLayout";

export default function RefundPolicy() {
  const s = useSettings();
  return (
    <PolicyLayout title="Refund & Cancellation Policy" kicker="Simple, fair, transparent">
      <p>At {s.brand} we want you to be completely satisfied with your purchase. This policy explains how order cancellations and refunds work.</p>

      <h2>1. Order cancellation by customer</h2>
      <ul>
        <li><b>Before dispatch:</b> You may cancel your order any time before it is dispatched from our warehouse, by contacting us at <ConfigField value={s.email} label="business email"/> or <ConfigField value={s.phone} label="phone number"/>. In such cases, if you had paid online, a full refund will be initiated within 3 business days.</li>
        <li><b>After dispatch:</b> Once the order has been handed over to the courier, we are unable to cancel it in transit. In this case, please refuse the parcel at the time of delivery, or accept it and follow our Return process (see <a href="/return-policy">Return & Replacement Policy</a>).</li>
      </ul>

      <h2>2. Order cancellation by {s.brand}</h2>
      <p>We reserve the right to cancel an order in the following situations:</p>
      <ul>
        <li>The product is out of stock or unavailable due to a stock discrepancy.</li>
        <li>The delivery address is outside our serviceable pincode network.</li>
        <li>We suspect the order is fraudulent or violates our Terms & Conditions.</li>
        <li>There is a genuine pricing error caused by a technical fault.</li>
      </ul>
      <p>If we cancel your order, you will be notified via email/SMS and a 100% refund will be initiated within 3 business days.</p>

      <h2>3. Refund process</h2>
      <p>Refunds are always processed to the original payment method:</p>
      <ul>
        <li><b>UPI, Cards, Net Banking, Wallet</b> — refund credited to the same source, typically within 5–7 business days after we initiate it.</li>
        <li><b>Cash on Delivery</b> — refund is sent as a bank transfer (NEFT) to the bank account you share with our support team, typically within 5–7 business days after we receive the returned product.</li>
      </ul>
      <p>The exact time to reflect in your bank account depends on your bank; if you don't see the refund after 10 business days, please share the ARN/refund reference we send you with your bank, or write to us.</p>

      <h2>4. Non-refundable items</h2>
      <p>For hygiene and religious reasons, the following are not eligible for refund or return once dispatched, <b>unless they arrive damaged, wrong, or defective</b>:</p>
      <ul>
        <li>Consumables such as ghee, oil, camphor, agarbatti, dhoop, roli, kumkum, chandan, akshat, mishri, dry fruits and packaged samagri that has been opened</li>
        <li>Customized puja kits assembled specifically to your requirement</li>
      </ul>

      <h2>5. Damaged, wrong or defective items</h2>
      <p>If your parcel arrives damaged, or contains the wrong item or a defective product, we will replace or refund it in full. Please see the detailed procedure in our <a href="/return-policy">Return & Replacement Policy</a>. You must report such issues within 48 hours of delivery.</p>

      <h2>6. How to request a refund</h2>
      <ol>
        <li>Email <ConfigField value={s.email} label="business email"/> with your order number, and — for damaged/wrong items — clear photos of the parcel and product.</li>
        <li>Our team will confirm eligibility within one business day.</li>
        <li>Once approved, refund is initiated to your original payment method (or your bank account for COD).</li>
      </ol>

      <h2>7. Questions?</h2>
      <p>Reach out any time via our <a href="/contact">Contact page</a>, email <ConfigField value={s.email} label="business email"/>, or WhatsApp us.</p>
    </PolicyLayout>
  );
}
